import { render, staticRenderFns } from "./BottomCart.vue?vue&type=template&id=24950a0c&scoped=true"
import script from "./BottomCart.vue?vue&type=script&lang=js"
export * from "./BottomCart.vue?vue&type=script&lang=js"
import style0 from "./BottomCart.vue?vue&type=style&index=0&id=24950a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24950a0c",
  null
  
)

export default component.exports